import '../icon';
import '../rich-text';
import '../text';
import { defineCustomElement, getAttribute, getLiteralAttribute, updateAttribute, updateLiteralAttribute, NectaryElement } from '../utils';
const templateHTML = '<style>:host{display:block}#wrapper{display:flex;flex-direction:row;gap:8px;align-items:center;padding:8px 16px;box-sizing:border-box;width:100%;min-height:48px}:host([type=warn]) #wrapper{background-color:var(--sinch-comp-alert-color-warning-default-background)}:host([type=error]) #wrapper{background-color:var(--sinch-comp-alert-color-error-default-background)}:host([type=info]) #wrapper{background-color:var(--sinch-comp-alert-color-info-default-background)}#icon-error,#icon-info,#icon-warn{display:none}#icon-warn{--sinch-global-color-icon:var(--sinch-comp-alert-color-warning-default-icon)}#icon-error{--sinch-global-color-icon:var(--sinch-comp-alert-color-error-default-icon)}#icon-info{--sinch-global-color-icon:var(--sinch-comp-alert-color-info-default-icon)}:host([type=error]) #icon-error,:host([type=info]) #icon-info,:host([type=warn]) #icon-warn{display:block}#text{display:flex;flex-direction:column;gap:8px;flex:1;min-width:0;--sinch-comp-rich-text-font:var(--sinch-comp-alert-font-body)}:host([type=warn]) #text{--sinch-global-color-text:var(--sinch-comp-alert-color-warning-default-text)}:host([type=error]) #text{--sinch-global-color-text:var(--sinch-comp-alert-color-error-default-text)}:host([type=info]) #text{--sinch-global-color-text:var(--sinch-comp-alert-color-info-default-text)}</style><div id="wrapper"><sinch-icon id="icon-info" name="info"></sinch-icon><sinch-icon id="icon-warn" name="report_problem"></sinch-icon><sinch-icon id="icon-error" name="report"></sinch-icon><sinch-rich-text id="text"></sinch-rich-text><slot name="action"></slot><slot name="close"></slot></div>';
import { typeValues } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-alert', class extends NectaryElement {
  #$text;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$text = shadowRoot.querySelector('#text');
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'alert');
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  static get observedAttributes() {
    return ['text'];
  }
  attributeChangedCallback(name, _, newVal) {
    switch (name) {
      case 'text':
        {
          updateAttribute(this.#$text, 'text', newVal);
          break;
        }
    }
  }
  get type() {
    return getLiteralAttribute(this, typeValues, 'type');
  }
  set type(value) {
    updateLiteralAttribute(this, typeValues, 'type', value);
  }
  get text() {
    return getAttribute(this, 'text', '');
  }
  set text(value) {
    updateAttribute(this, 'text', value);
  }
});